import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api/v1',
  timeout: 15000,
});

// ==================== 前台 API ====================
export const getBanners = () => api.get('/banners').then(r => r.data.data);
export const getSiteStats = () => api.get('/site/stats').then(r => r.data.data);
export const getSiteConfig = () => api.get('/site/config').then(r => r.data.data);

// ── v2.0 方案分类（树形） ──
export const getCategories = () => api.get('/categories').then(r => r.data.data);
export const getCategoryDetail = (id) => api.get(`/categories/${id}`).then(r => r.data.data);

// ── v2.0 行业方案 ──
export const getSolutions = (params) => api.get('/solutions', { params }).then(r => r.data.data);
export const getSolutionById = (id) => api.get(`/solutions/${id}`).then(r => r.data.data);

// ── 兼容旧接口（行业分类列表） ──
export const getIndustries = () => api.get('/industries').then(r => r.data.data);
export const getProducts = (params) => api.get('/products', { params }).then(r => r.data.data);
export const getProductById = (id) => api.get(`/products/${id}`).then(r => r.data.data);

export const getNewsList = (params) => api.get('/news', { params }).then(r => r.data.data);
export const getLatestNews = () => api.get('/news/latest').then(r => r.data.data);
export const getNewsById = (id) => api.get(`/news/${id}`).then(r => r.data.data);
export const submitLead = (data) => api.post('/leads', data).then(r => r.data);
export const getPartners = () => api.get('/about/partners').then(r => r.data.data);
export const getQualifications = () => api.get('/about/qualifications').then(r => r.data.data);
export const getAboutProfile = () => api.get('/about/profile').then(r => r.data.data);
export const getCulture = () => api.get('/about/culture').then(r => r.data.data);
export const getCustomerLogos = () => api.get('/about/customer-logos').then(r => r.data.data);
export const getJobs = () => api.get('/jobs').then(r => r.data.data);
export const getJobById = (id) => api.get(`/jobs/${id}`).then(r => r.data.data);

export default api;
